define(['exports', 'css!./userMapping.css', 'text!./userMapping.html'], function (exports, _userMapping, _userMapping3) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.init = init;

    var _userMapping2 = _interopRequireDefault(_userMapping);

    var _userMapping4 = _interopRequireDefault(_userMapping3);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /**
     * Created by chief on 16/7/4.
     */

    var userMapping = {
        comp: null,
        init: function init(content) {
            var self = this;
            page();
            function page(num, size) {
                content.innerHTML = _userMapping4.default;
                $('#manager-main input').placeholder();
                var element = document.getElementById("pagination");
                var comp = new u.pagination({ el: element, showState: true, jumppage: true });
                comp.on('pageChange', function (pageIndex) {
                    page(pageIndex + 1, $('.page_z').val());
                });
                comp.on('sizeChange', function (arg) {
                    page(1, arg);
                });
                userMapping.comp = comp;
                num = num || 1;
                size = size || 10;
                var key = $('#inputSuccess2').val();
                if (key) {
                    userMapping.search(null, null, num, size);
                } else {
                    $.ajax({
                        url: contextRoot + '/usermgr/page?pn=' + num + '&ps=' + size + '&random=' + Math.random(),
                        dataType: 'json',
                        type: 'get',
                        contentType: 'application/json',
                        beforeSend: function beforeSend() {
                            window.loadShow();
                        },
                        success: function success(res) {
                            window.loadHide();
                            if (res.status == '1') {
                                $('#umTbody .no-data').parents('tr').remove();
                                var data = res.users.content || [];
                                if (data && data.length) {
                                    ko.cleanNode(document.getElementById('content'));
                                    var str = '<tr data-bind="click:$root.mapping">' + '<td data-bind="text:name"></td>' + '<td data-bind="text:userCode"></td>' + '<td data-bind="text:registerDate"></td>' + '<td data-bind="text:userMobile"></td>' + '</tr>';
                                    $('#content').find('tbody[data-bind="foreach:user"]').html(str);
                                    comp.update({ totalPages: res.users.totalPages, pageSize: res.users.size, currentPage: num, totalCount: res.users.totalElements });
                                    self.bind(data);
                                    if (num == 1 && num == '1') {
                                        var result = res.users.totalElements > 10 ? true : false;
                                        if (result) {
                                            $('.paginate-box').show();
                                        } else {
                                            $('.paginate-box').hide();
                                        }
                                    } else {
                                        $('.paginate-box').show();
                                    }
                                } else {
                                    self.bind(data);
                                    $('#umTbody').html('');
                                    $('#umTbody').append('<td colspan="4" class="no-data">暂时还没有数据~！</td>');
                                    $('#umTbody .no-data').parents('tr').siblings().hide();
                                    $('.paginate-box').hide();
                                    document.getElementById('userM').innerHTML = '<tr><td colspan="3" class="no-data">暂时还没有数据~！</td></tr>';
                                }
                            } else {
                                alert(res.msg);
                            }
                        }
                    });
                }
            };
        },
        search: function search(mod, e, num, size, self) {
            num = num || 1;
            size = size || 10;
            var keyword = $('#inputSuccess2').val();
            $.ajax({
                url: contextRoot + '/usermgr/page?search_LIKE_name=' + keyword + '&pn=' + num + '&ps=' + size + '&random=' + Math.random(),
                dataType: 'json',
                type: 'get',
                contentType: 'application/json',
                beforeSend: function beforeSend() {
                    window.loadShow();
                },
                success: function success(res) {
                    window.loadHide();
                    if (res.status == "1") {
                        $('#umTbody .no-data').parents('tr').remove();
                        var data = res.users.content;
                        if (data && data.length) {
                            self.user.removeAll();
                            $.each(data, function (i, item) {
                                self.user.push(item);
                            });
                            userMapping.comp.update({ totalPages: res.users.totalPages, pageSize: res.users.size, currentPage: num, totalCount: res.users.totalElements });
                            var result = res.users.totalElements > 10 ? true : false;
                            if (result) {
                                $('.paginate-box').show();
                            } else {
                                if (num == 1) {
                                    $('.paginate-box').hide();
                                }
                            }
                            $('#umTbody').find('tr:first').trigger('click');
                        } else {
                            $('#umTbody').append('<tr><td colspan="4" class="no-data">暂时还没有数据~！</td></tr>');
                            $('#umTbody .no-data').parents('tr').siblings().hide();
                            $('.paginate-box').hide();
                            document.getElementById('userM').innerHTML = '<tr><td colspan="3" class="no-data">暂时还没有数据~！</td></tr>';
                        }
                    } else {
                        alert(res.msg);
                    }
                }
            });
        },
        bind: function bind(model) {
            var GiftModel = function GiftModel(gifts) {
                var self = this;
                //禁止输入 所有符号
                $('#inputSuccess2').bind('keyup', function () {
                    var value = $(this).val();
                    var reg = /[^A-Za-z0-9\u4e00-\u9fa5]/;
                    if (reg.test(value)) {
                        var symbol = reg.exec(value)[0];
                        $(this).val(value.replace(symbol, ''));
                    }
                    if (value.indexOf('……') != -1) {
                        var val = $(this).val();
                        $(this).val(val.replace('……', ''));
                    }
                    if (event.keyCode == 13) {
                        $('#searchBtn').trigger('click');
                        $("#inputSuccess2").blur();
                    }
                });
                //失去焦点去掉所有特殊符号
                $("#inputSuccess2").blur(function () {
                    var value = $(this).val();
                    var msg = value.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, "");
                    $(this).val(msg);
                });
                //

                self.user = ko.observableArray(gifts);

                self.mappings = ko.observableArray([]);

                self.userMapping = ko.observableArray([]);

                self.code = ko.observable('');

                self.backPage = function () {
                    window.location.href = window.location.protocol + '//' + window.location.host + window.location.pathname;
                };
                self.search = function () {
                    userMapping.search(null, null, 1, 10, self);
                };

                self.usermapping = function (gift, e) {
                    var index = $(event.target).closest('tr').index();
                    window.md = u.dialog({ id: 'userMappingId', content: "#modalMapping", hasCloseMenu: true }); //不要修改testDoalg css中涉及到
                    $.ajax({
                        url: '/integration/usermapping/system/verifyitem/' + gift.systemCode + '?random=' + Math.random(),
                        dataType: 'json',
                        type: 'get',
                        contentType: 'application/json',
                        beforeSend: function beforeSend() {
                            window.loadShow();
                        },
                        success: function success(res) {
                            window.loadHide();
                            if (res.status == "1") {
                                self.userMapping.removeAll();
                                $.each(res.data, function (i, item) {
                                    self.userMapping.push(item);
                                });
                                self.userMapping.code = gift.systemCode;
                                self.mappings.index = index;
                                $('#umTbody').find('tr.bgClick').trigger('click');
                            } else {
                                alert(res.message);
                            }
                        }
                    });
                };

                self.saveUsermapping = function () {
                    var str = '';
                    $('#modalMapping').find('.u-input-group-before').parent().parent().find('input').each(function (i, v) {
                        if (!$(v).val()) {
                            str = '请输入必填项';
                        }
                    });
                    if (str) {
                        alert(str);
                        return;
                    }
                    var index = self.mappings.index;
                    var mapping = self.mappings();
                    var mp = $.map(mapping, function (n) {
                        return n;
                    });

                    var data = self.userMapping(),
                        d = [];
                    $.each(data, function (i, item) {
                        d.push({ id: item.id, value: item.defVal });
                    });
                    d.push({ id: "pt_systemcode", value: self.userMapping.code });
                    d.push({ id: "pt_usercode", value: self.mappings.code });

                    var data = ko.utils.stringifyJson(d);

                    $.ajax({
                        url: '/integration/usermapping/credential',
                        dataType: 'json',
                        data: data,
                        type: 'post',
                        contentType: 'application/json',
                        beforeSend: function beforeSend() {
                            window.loadShow();
                        },
                        success: function success(res) {
                            window.loadHide();
                            if (res.status == "1") {
                                window.message();
                                md.close();
                                $('#modalMapping').modal('hide');
                                $('#tokenSucess').removeClass('hide-class');
                                setTimeout(function () {
                                    $('#tokenSucess').addClass('hide-class');
                                }, 500);
                                self.mappings.removeAll();
                                mp[index].status = "1";
                                $.each(mp, function (i, item) {
                                    self.mappings.push(item);
                                });
                                $('#umTbody').find('tr.bgClick td').eq(0).trigger('click');
                            } else {
                                window.message('<i class="iconfont icon-tishi"></i>' + res.message, 'error');
                            }
                        }
                    });
                };
                self.mdClose = function () {
                    md.close();
                };

                self.mapping = function (gift, e, pageSize) {
                    var lastTr = $('#userM').find('tr:last-of-type');
                    if (!lastTr.hasClass('old')) {
                        lastTr.remove();
                    }
                    $('#userM').find('tr td.show-more').remove();
                    pageSize = pageSize || 10;
                    var p = null;
                    if (e.target.nodeName == 'TD') {
                        p = $(e.target).parent();
                    } else if (e.target.nodeName == 'TR') {
                        p = $(e.target);
                    }
                    p.addClass('bgClick').siblings().removeClass('bgClick');
                    var index = p.index();
                    $('.user-left tr').removeClass('hover');
                    p.addClass('hover');
                    var code = gift.userCode;
                    self.code = code;
                    $('#manager-main').attr('code', code);
                    $.ajax({
                        url: '/integration/usermapping/associate/' + code + '?pageIndex=0&pageSize=' + pageSize + '&random=' + Math.random(),
                        dataType: 'json',
                        type: 'get',
                        contentType: 'application/json',
                        beforeSend: function beforeSend() {
                            window.loadShow();
                        },
                        success: function success(res) {
                            window.loadHide();
                            if (res.status == "1") {
                                self.mappings.removeAll();
                                if (res.data && res.data.content && res.data.content.length) {
                                    var data = res.data.content;
                                    for (var i = 0; i < data.length; i++) {
                                        var temp = data[i];
                                        self.mappings.push(temp);
                                    }
                                    self.mappings.code = code;
                                    if (pageSize < res.data.totalElements) {
                                        var str = '<tr><td colspan="3" class="no-data show-more">显示更多<i class="iconfont icon-arrow-down"></i></td></tr>';
                                        $('#userM').append(str);
                                        $('#userM').find('tr td.show-more').on('click', function () {
                                            $('#userM').find('tr td.show-more').remove();
                                            self.mapping(gift, e, 999999);
                                            $('#userM').find('tr:last-of-type').remove();
                                        });
                                    }
                                } else {
                                    document.getElementById('userM').innerHTML = '<tr><td colspan="3" class="no-data">暂时还没有数据~！</td></tr>';
                                }
                            }
                        }
                    });
                };
                self.cancelMappingFake = function () {
                    $('#cancelMapping').trigger('click');
                    md.close();
                };
                self.cancelUserMapping = function (gift, e) {
                    var index = $(event.target).closest('tr').index();
                    window.md = u.dialog({ id: 'canelDialg', content: "#cancelUser", hasCloseMenu: true });
                    $('.u-msg-dialog').css('width', '340px');
                    $('.u-msg-dialog').css('height', '160px');
                    $('button.primary').removeClass('primary').addClass('u-button-info');
                };
                self.cancelMapping = function (gift, event) {
                    var index = $(event.target).closest('tr').index();
                    var mapping = self.mappings();
                    var data = $.map(mapping, function (n) {
                        return n;
                    });
                    $.ajax({
                        url: '/integration/usermapping/associate/cancel/' + self.mappings.code + '/' + gift.systemCode + '?random=' + Math.random(),
                        dataType: 'json',
                        type: 'get',
                        contentType: 'application/json',
                        beforeSend: function beforeSend() {
                            window.loadShow();
                        },
                        success: function success(res) {
                            window.loadHide();
                            if (res.status == "1") {
                                window.message();
                                self.mappings.removeAll();
                                data[index].status = "0";
                                $.each(data, function (i, item) {
                                    self.mappings.push(item);
                                });
                                $('#umTbody').find('tr.bgClick td').eq(0).trigger('click');
                            } else {
                                window.message('<i class="iconfont icon-tishi"></i>' + res.message, 'error');
                            }
                        }
                    });
                };
                self.save = function (form) {
                    var extendAttributes = self.extendAttributes();
                    var o = {};
                    $.each(extendAttributes, function (i, item) {
                        o[item['project']] = item['val'];
                    });
                    //拼接gifts数据
                    var setting = self.newManager()[0].setting;

                    setting.verify.verifyItem = self.gifts();
                    setting.ipmapping.ipMappings = self.ipMappings();
                    setting.extendAttributes = o;
                    var data = self.newManager()[0];
                    $.ajax({
                        url: '/integration/system/save',
                        dataType: 'json',
                        data: JSON.stringify(data),
                        type: 'post',
                        contentType: 'application/json',
                        beforeSend: function beforeSend() {
                            window.loadShow();
                        },
                        success: function success(res) {
                            window.loadHide();
                            if (res.status == "1") {
                                alert('保存成功!');
                            }
                        }
                    });
                };
                self.changBg = function (mod, e) {
                    $(e.target).parents('tr').addClass('bgClick').siblings().removeClass('bgClick');
                    if ($(e.target).parent('a').length) {
                        window.open($(e.target).parent('a').attr('href'));
                    }
                };
            };
            var viewModel = new GiftModel(model);
            ko.applyBindings(viewModel, document.getElementById('content'));
            $('table').eq(0).find('tr').eq(1).find('td').eq(0).trigger('click');
        }
    };

    function init(content) {
        userMapping.init(content);
    }
});